/*SEO pages context ids for Ads*/
export const MOBILE_SEO_ROUTES_CID = 'UkFJTCNUUkFJTlMgU0VPIC0gUk9VVEUgVEVNUExBVEUgLSBNT0JJTEUjVE9QIEZPTEQ=';
export const MOBILE_SEO_TRAINS_CID = 'UkFJTCNUUkFJTlMgU0VPIC0gVFJBSU4gVEVNUExBVEUgLSBNT0JJTEUjVE9QIEZPTEQ=';
export const MOBILE_SEO_STATION_CID = 'UkFJTCNUUkFJTlMgU0VPIC0gU1RBVElPTiBURU1QTEFURSAtIE1PQklMRSNUT1AgRk9MRA==';
export const MOBILE_SEO_IRCTC_CREATE_ACCOUNT_CID = 'UkFJTCNTRU8gSVJDVEMgQUNDT1VOVCBQQUdFUyNUT1A=';
export const MOBILE_SEO_IRCTC_FORGOT_USERNAME_CID = 'UkFJTCNTRU8gSVJDVEMgQUNDT1VOVCBQQUdFUyNUT1A=';
export const MOBILE_SEO_IRCTC_FORGOT_PASSWORD_CID = 'UkFJTCNTRU8gSVJDVEMgQUNDT1VOVCBQQUdFUyNUT1A=';
export const MOBILE_SEO_IRCTC_LOGIN_CID = 'UkFJTCNTRU8gSVJDVEMgRU5UUlkgUEFHRSNUT1A=';
export const DESKTOP_SEO_ROUTES_CID = 'UkFJTCNUUkFJTlMgU0VPIC0gUk9VVEUgVEVNUExBVEUgLSBERVNLVE9QI1RPUCBGT0xE';
export const DESKTOP_SEO_TRAINS_CID = 'UkFJTCNUUkFJTlMgU0VPIC0gVFJBSU4gVEVNUExBVEUgLSBERVNLVE9QI1RPUCBGT0xE';
export const DESKTOP_SEO_STATION_CID = 'UkFJTCNUUkFJTlMgU0VPIC0gU1RBVElPTiBURU1QTEFURSAtIERFU0tUT1AjVE9QIEZPTEQ=';
export const DESKTOP_SEO_IRCTC_CREATE_ACCOUNT_CID = 'UkFJTCNTRU8gSVJDVEMgQUNDT1VOVCBQQUdFUyNUT1A=';
export const DESKTOP_SEO_IRCTC_FORGOT_USERNAME_CID = 'UkFJTCNTRU8gSVJDVEMgQUNDT1VOVCBQQUdFUyNUT1A=';
export const DESKTOP_SEO_IRCTC_FORGOT_PASSWORD_CID = 'UkFJTCNTRU8gSVJDVEMgQUNDT1VOVCBQQUdFUyNUT1A=';
export const DESKTOP_SEO_IRCTC_LOGIN_CID = 'UkFJTCNTRU8gSVJDVEMgRU5UUlkgUEFHRSNUT1A=';
export const RAILS_LANDING_AD1 = 'UkFJTCNSQUlMIEJVUyBDT01NT04gTEFORElORyNUT1AgRk9MRCBCQU5ORVIgMg==';
export const RAILS_LANDING_AD2 = 'UkFJTCNSQUlMIEJVUyBDT01NT04gTEFORElORyNUT1AgRk9MRCBCQU5ORVIgMw==';
export const RAILS_LANDING_EXCLUSIVE_PARTNERS = 'UkFJTCNSQUlMIEJVUyBDT01NT04gTEFORElORyNBREZFRUQgMiBCQU5ORVIgMiA=';
export const RAILS_LANDING_SNACKBAR = 'UkFJTCNSQUlMIEJVUyBDT01NT04gTEFORElORyNTTkFDS0JBUg==';
export const RAIL_TRAINS_SEO_ROUTE_TEMPLATE_MOBILE_CID =
  'UkFJTCNSQUlMIFRSQUlOUyBTRU8gLSBST1VURSBURU1QTEFURSAtIE1PQklMRSNTRUNPTkQgRk9MRA==';
export const RAIL_TRAINS_SEO_ROUTE_TEMPLATE_DESKTOP_CID =
  'UkFJTCNSQUlMIFRSQUlOUyBTRU8gLSBST1VURSBURU1QTEFURSAtIERFU0tUT1AjU0VDT05EIEZPTEQ=';
export const TRAINS_SEO_TRAIN_TEMPLATE_MOBILE_SECOND_FOLD_CID =
  'UkFJTCNUUkFJTlMgU0VPIC0gVFJBSU4gVEVNUExBVEUgLSBNT0JJTEUjU0VDT05EIEZPTEQ=';
export const RAIL_TRAINS_SEO_ROUTE_TEMPLATE_MOBILE_MIDDLE_TOP_FOLD_CID =
  'UkFJTCNSQUlMIFRSQUlOUyBTRU8gLSBST1VURSBURU1QTEFURSAtIE1PQklMRSNUT1AgTUlERExFIEZPTEQ=';
export const RAIL_TRAINS_SEO_TRAIN_TEMPLATE_MOBILE_THIRD_FOLD_CID =
  'UkFJTCNUUkFJTlMgU0VPIC0gVFJBSU4gVEVNUExBVEUgLSBNT0JJTEUjVEhJUkQgRk9MRA==';
export const TRAINS_SEO_ROUTE_TEMPLATE_LISTING_1 =
  'UkFJTCNSQUlMIFRSQUlOUyBTRU8gLSBST1VURSBURU1QTEFURSAtIERFU0tUT1AjTElTVElOR18x';

export const AD_PAGES = {
  TRAIN_INFO_PAGE: {
    adsPageName: 'TRAIN_INFO_PAGE',
    mobileContextId: MOBILE_SEO_TRAINS_CID,
    desktopContextId: DESKTOP_SEO_TRAINS_CID
  },
  ROUTE_INFO_PAGE: {
    adsPageName: 'ROUTE_INFO_PAGE',
    mobileContextId: MOBILE_SEO_ROUTES_CID,
    desktopContextId: DESKTOP_SEO_ROUTES_CID
  },
  STATION_INFO_PAGE: {
    adsPageName: 'STATION_INFO_PAGE',
    mobileContextId: MOBILE_SEO_STATION_CID,
    desktopContextId: DESKTOP_SEO_STATION_CID
  },
  IRCTC_LOGIN_PAGE: {
    adsPageName: 'IRCTC_LOGIN_PAGE',
    mobileContextId: MOBILE_SEO_IRCTC_LOGIN_CID,
    desktopContextId: DESKTOP_SEO_IRCTC_LOGIN_CID
  },
  IRCTC_CREATE_ACCOUNT_PAGE: {
    adsPageName: 'IRCTC_CREATE_ACCOUNT_PAGE',
    mobileContextId: MOBILE_SEO_IRCTC_CREATE_ACCOUNT_CID,
    desktopContextId: DESKTOP_SEO_IRCTC_CREATE_ACCOUNT_CID
  },
  IRCTC_FORGOT_PASSWORD_PAGE: {
    adsPageName: 'IRCTC_FORGOT_PASSWORD_PAGE',
    mobileContextId: MOBILE_SEO_IRCTC_FORGOT_PASSWORD_CID,
    desktopContextId: DESKTOP_SEO_IRCTC_FORGOT_PASSWORD_CID
  },
  IRCTC_FORGOT_USERNAME_PAGE: {
    adsPageName: 'IRCTC_FORGOT_USERNAME_PAGE',
    mobileContextId: MOBILE_SEO_IRCTC_FORGOT_USERNAME_CID,
    desktopContextId: DESKTOP_SEO_IRCTC_FORGOT_USERNAME_CID
  },
  RAIL_TRAINS_SEO_ROUTE_TEMPLATE: {
    adsPageName: 'RAIL_TRAINS_SEO_ROUTE_TEMPLATE',
    mobileContextId: RAIL_TRAINS_SEO_ROUTE_TEMPLATE_MOBILE_CID,
    desktopContextId: RAIL_TRAINS_SEO_ROUTE_TEMPLATE_DESKTOP_CID
  },
  TRAINS_SEO_TRAIN_TEMPLATE_MOBILE_SECOND_FOLD: {
    adsPageName: 'TRAINS_SEO_TRAIN_TEMPLATE_MOBILE_SECOND_FOLD',
    mobileContextId: TRAINS_SEO_TRAIN_TEMPLATE_MOBILE_SECOND_FOLD_CID
  },
  RAIL_TRAINS_SEO_ROUTE_TEMPLATE_MOBILE_MIDDLE_TOP_FOLD: {
    adsPageName: 'RAIL_TRAINS_SEO_ROUTE_TEMPLATE_MOBILE_MIDDLE_TOP_FOLD',
    mobileContextId: RAIL_TRAINS_SEO_ROUTE_TEMPLATE_MOBILE_MIDDLE_TOP_FOLD_CID
  },
  RAIL_TRAINS_SEO_TRAIN_TEMPLATE_MOBILE_THIRD_FOLD: {
    adsPageName: 'RAIL_TRAINS_SEO_TRAIN_TEMPLATE_MOBILE_THIRD_FOLD',
    mobileContextId: RAIL_TRAINS_SEO_TRAIN_TEMPLATE_MOBILE_THIRD_FOLD_CID
  },
  TRAINS_SEO_ROUTE_TEMPLATE_LISTING_1: {
    adsPageName: 'TRAINS_SEO_ROUTE_TEMPLATE_LISTING_1',
    desktopContextId: TRAINS_SEO_ROUTE_TEMPLATE_LISTING_1
  },
  RAILS_LANDING_AD: {
    adsPageName: 'RAILS_LANDING_AD',
    mobileContextId: [RAILS_LANDING_AD1, RAILS_LANDING_AD2]
  },
  RAILS_LANDING_EXCLUSIVE_PARTNERS: {
    adsPageName: 'RAILS_LANDING_EXCLUSIVE_PARTNERS',
    mobileContextId: RAILS_LANDING_EXCLUSIVE_PARTNERS
  },
  RAILS_LANDING_SNACKBAR: {
    adsPageName: 'RAILS_LANDING_SNACKBAR',
    mobileContextId: RAILS_LANDING_SNACKBAR
  }
};
